import { Location } from "@angular/common";
import { Component, OnInit, Input, DestroyRef, inject } from "@angular/core";
import * as AppSelectors from "../../store/app/app.selectors";
import { Store } from "@ngrx/store";
import { AppState } from "../../store/app/app.state";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AppStateService } from "src/app/shared/services/app-state.service";

enum SplashAnimationType {
  SlideLeft = "slide-left",
  SlideRight = "slide-right",
  FadeOut = "fade-out"
}

@Component({
    selector: "urban-splash-screen",
    templateUrl: "./splash-screen.component.html",
    styleUrls: ["./splash-screen.component.scss"],
    standalone: false
})
export class SplashScreenComponent implements OnInit {

  @Input() animationDuration: number;
  @Input() animationType: SplashAnimationType = SplashAnimationType.SlideLeft;

  public windowWidth: string;
  public splashTransition: string;
  public opacityChange: number = 1;
  public showSplash = true;
  public subscribedDomainLogo: string;
  public subscribedThemeTitle: string;
  private splashStartTime: number;
  private readonly minimumDisplayTime = 1500; //ms

  private readonly appStore = inject(Store<AppState>);
  private readonly location = inject(Location);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly appStateService = inject(AppStateService);

  constructor() {
    this.splashStartTime = Date.now();
  }

  ngOnInit(): void {
    this.appStore.select(AppSelectors.getTheme).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(theme => {
      if (theme && theme?.SplashScreenLogo) {
        this.subscribedDomainLogo = theme.SplashScreenLogo
        const appLogo = document.getElementById('app-logo');
        if (appLogo) {
          const i = new Image();

          i.onload = () => {
            appLogo.style.background = `url(${this.subscribedDomainLogo}) no-repeat center`;
            appLogo.style.width = `${i.width}px`;
            appLogo.style.height = `${i.height}px`;
          };

          i.src = theme.SplashScreenLogo;
        }
      }
      if (theme && theme?.Translations.find(x => x.Key === 'title')) {
        this.subscribedThemeTitle = theme?.Translations.find(x => x.Key === 'title')?.Value;
      }
    });

    this.appStateService.isInitializing.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isInitializing => {
      if (!isInitializing && this.showSplash) {
        this.hideSplashScreen();
      }
    });
  }

  private hideSplashScreen(): void {
    if (this.location.path(false).includes('auth') || this.location.path(false) === '') {
      const elapsedTime = Date.now() - this.splashStartTime;
      const remainingTime = Math.max(0, this.minimumDisplayTime - elapsedTime);

      setTimeout(() => {
        let transitionStyle = "";
        switch (this.animationType) {
          case SplashAnimationType.SlideLeft:
            this.windowWidth = "-" + window.innerWidth + "px";
            transitionStyle = "left " + this.animationDuration + "s";
            break;
          case SplashAnimationType.SlideRight:
            this.windowWidth = window.innerWidth + "px";
            transitionStyle = "left " + this.animationDuration + "s";
            break;
          case SplashAnimationType.FadeOut:
            transitionStyle = "opacity " + this.animationDuration + "s";
            this.opacityChange = 0;
        }

        this.splashTransition = transitionStyle;

        setTimeout(() => {
          this.showSplash = false;
          this.appStateService.markSplashDone();
        }, this.animationDuration * 1000);
      }, remainingTime);
    } else {
      this.showSplash = false;
      this.appStateService.markSplashDone();
    }
  }
}